import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import "./Sidebar.css";
import SearchChatModal from "./SearchChatModal"; // sesuaikan path
import { Menu, ChevronRight, Search, Folder, FolderPlus, SeparatorHorizontal } from "lucide-react";
import { Xmark, ChatPlusIn, HomeAlt ,HomeSimpleDoor, HomeUser, UserCircle, LogOut, EditPencil, BinMinusIn, MoreHoriz, Learning, Brain} from "iconoir-react";
import axios from "axios";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
import MemoryModal from "./MemoryModal";


const Sidebar = ({ collapsed, setCollapsed, masterChatList = [], onNewChat, userData, refreshMasterChatList,onSelectChat }) => {
  const cookies = new Cookies();
  const [hoveredItem, setHoveredItem] = useState(null);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const [footerMenuOpen, setFooterMenuOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [localList, setLocalList] = useState(masterChatList);
  const footerRef = useRef(null);
  const [searchModalVisible, setSearchModalVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const memoryRootRef = useRef(null);

  // ADD THESE FOR INFINITE SCROLL
  const [displayedItems, setDisplayedItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const itemsPerPage = 15; // Adjust as needed
  const leftScrollRef = useRef(null);
  const menuRef = useRef(null);

useEffect(() => {
  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setOpenMenuIndex(null);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, []);

const FooterMenu = ({ ref, collapsed, sessionData, portalURL, handleLogout, onClose }) => {
  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        ref.current && 
        !ref.current.contains(event.target)
      ) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  // Calculate position based on anchor element
  const getMenuPosition = (collapsed) => {

    

    if (!collapsed) return { 
      bottom: `20`,
      left: `0`,
      marginLeft:'25px',
      marginBottom: '10px',
    };
    
    return {
      bottom: `20`,
      left: `0`,
      marginLeft:'25px',
      marginBottom: '25px',
    };
  };

  // Handle menu item clicks - close menu after action
  const handleMenuItemClick = (action) => {
    return () => { 
      onClose();  
      action(); 
    };
  };

  return createPortal(
    <div 
      ref={ref}
      className="footer-more-menu global"
      style={getMenuPosition(collapsed)}
    >
      <div className="footer-menu-item user-email">
        <UserCircle /> &nbsp;
        {sessionData.email || "user@befa.id"}
      </div>
      {/* <div
        className="footer-menu-item"
        onClick={handleMenuItemClick(handlePersonalization)}
      >
        <HomeUser /> &nbsp;
        Personalisasi
      </div>
      <div
        className="footer-menu-item"
        onClick={handleMenuItemClick(handleMemoryzation)}
      >
        <Brain /> &nbsp;
        Memorisasi
      </div> */}
      <div className="footer-divider"></div>
      <div
        className="footer-menu-item"
        onClick={handleMenuItemClick(() => window.open(portalURL, "_blank"))}
      >
        <HomeAlt /> &nbsp;
        Kembali ke Portal
      </div>
      <div
        className="footer-menu-item"
        onClick={handleMenuItemClick(handleLogout)}
      >
        <LogOut /> &nbsp;
        Keluar
      </div>
    </div>,
    document.body
  );
};

  const sessionData = cookies.get("sessionData", { path: "/" });
  //console.log("sessionData logging here blabal")
  //console.log(sessionData)
  useEffect(() => {
    setLocalList(masterChatList);
  }, [masterChatList]);

  // REPLACE THE displayItems useEffect WITH THIS:
  useEffect(() => {
    // Initialize displayedItems with first page
    const initialItems = masterChatList.slice(0, itemsPerPage);
    setDisplayedItems(initialItems);
    setCurrentPage(1);
    setHasMore(masterChatList.length > itemsPerPage);
  }, [masterChatList]);

  // REPLACE THE loadMoreItems FUNCTION WITH THIS:
  const loadMoreItems = () => {
    if (isLoading || !hasMore) return;
    
    setIsLoading(true);
    const nextPage = currentPage + 1;
    const startIndex = 0; // Always start from beginning
    const endIndex = nextPage * itemsPerPage;
    
    // Use setTimeout to simulate async operation
    setTimeout(() => {
      const newItems = masterChatList.slice(0, endIndex);
      setDisplayedItems(newItems);
      setCurrentPage(nextPage);
      setHasMore(masterChatList.length > newItems.length);
      setIsLoading(false);
    }, 100);
  };

  // ADD THIS SCROLL HANDLER
  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    
    // Load more when near bottom (within 50px)
    if (scrollHeight - scrollTop <= clientHeight + 50 && hasMore && !isLoading) {
      loadMoreItems();
    }
  };

  const portalURL = `${process.env.REACT_APP_PORTAL_DESTINATION}dashboard`;

  const topMenu = [
    {
      icon: <ChatPlusIn size={22} />,
      label: "Obrolan Baru",
      action: () => onNewChat && onNewChat(),
    },
    {
      icon: <Search size={22} />,
      label: "Cari Obrolan",
      action: () => setSearchModalVisible(true),
    },
  ];

  const toggleMenu = (index) => {
    if (openMenuIndex === index) {
      setOpenMenuIndex(null);
    } else {
      setOpenMenuIndex(index);
    }
  };

  const handleMenuClick = async (action, chat) => {
    setOpenMenuIndex(null);
    if (action === "ubah") {
      setEditingId(chat.id);
      setEditValue(chat.judul_chat || chat.title || "");
    } else if (action === "hapus") {
      await handleDeleteChat(chat);
    }
  };

  const handleUpdateTitle = async (chatId, newTitle) => {
  const token = cookies.get("sessionToken");
  if (!token) {
    console.warn("❌ No session token found");
    return;
  }

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_PORTAL_DESTINATION}chat/update-title`,
      { masterID: chatId, newTitle },
      { headers: { Authorization: `${token}` } }
    );

    if (res.data.status !== "success") {
      console.warn("⚠️ Update title gagal:", res.data);
    }
  } catch (err) {
    console.error("❌ Gagal update judul:", err);
  }
};


  const handleDeleteChat = async (chat) => {
    const token = cookies.get("sessionToken");
    if (!token) {
      console.warn("❌ Token tidak ditemukan");
      return;
    }

    const confirmDelete = await Swal.fire({
      title: "Hapus Obrolan?",
      text: `Apakah kamu yakin ingin menghapus obrolan "${chat.judul_chat}"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Ya, hapus!",
      cancelButtonText: "Batal",
    });

    if (!confirmDelete.isConfirmed) return;

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_PORTAL_DESTINATION}chat/delete`,
        { masterID: chat.id },
        { headers: { Authorization: `${token}` } }
      );

      if (res.data.status === "success") {
        await Swal.fire({
          title: "Berhasil!",
          text: "Obrolan telah dihapus.",
          icon: "success",
          confirmButtonColor: "#3085d6",
        });

        window.location.href = process.env.REACT_APP_SELF_PATH_DESTINATION;
      } else {
        Swal.fire({
          title: "Gagal",
          text: "Tidak dapat menghapus obrolan. Coba lagi nanti.",
          icon: "error",
        });
      }
    } catch (err) {
      console.error("❌ Gagal menghapus chat:", err);
      Swal.fire({
        title: "Terjadi Kesalahan",
        text: "Terjadi error saat menghapus obrolan.",
        icon: "error",
      });
    }
  };

  const MenuItemWithTooltip = ({ item, collapsed, index, hoveredItem, setHoveredItem }) => {
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const menuItemRef = useRef(null);

  useEffect(() => {
    if (hoveredItem === index && menuItemRef.current) {
      const rect = menuItemRef.current.getBoundingClientRect();
      setTooltipPosition({
        top: rect.top + rect.height / 2 - 18,
        left: rect.right + 8
      });
    }
  }, [hoveredItem, index]);

  const handleClick = (e) => {
    setHoveredItem(null); // ← ADD THIS LINE
    item.action(e); // Call the original action
  };

  return (
    <div>
      <div
        ref={menuItemRef}
        className={collapsed ? "menu-item" : "menu-item-expand"}
        onClick={handleClick} // ← CHANGE from item.action to handleClick
        onMouseEnter={() => setHoveredItem(index)}
        onMouseLeave={() => setHoveredItem(null)}
        style={{ cursor: "pointer" }}
      >
        {item.icon} &nbsp;
        {!collapsed && <span>{item.label}</span>}
      </div>

      {/* Tooltip Portal */}
      {collapsed && hoveredItem === index && 
        createPortal(
          <div 
            className="portal-tooltip"
            style={{
              position: 'fixed',
              top: tooltipPosition.top,
              left: tooltipPosition.left,
              transform: '',
              zIndex: 9999
            }}
          >
            <div className="tooltip-content">
              {item.label}
            </div>
          </div>,
          document.body
        )
      }
    </div>
  );
};

  const handleLogout = () => {
    window.location.href = process.env.REACT_APP_PORTAL_DESTINATION + 'logout';
  };

  const handlePersonalization = async () => {
    const token = cookies.get("sessionToken");
    if (!token) return;

    let existingData = null;
    let isUpdate = false;

    // ===============================
    // 1️⃣ GET EXISTING DATA
    // ===============================
    try {
      console.log("Fetching existing personalisasi data...");
      console.log("Using token:", token);
      console.log("API URL:", `${process.env.REACT_APP_PATH_DESTINATION}/getPersonalisasi`);
      const res = await axios.get(
        `${process.env.REACT_APP_PATH_DESTINATION}/getPersonalisasi`,
        { headers: { Authorization: `${token}` } }
      );
      console.log("Existing personalisasi data:", res.data);
      if (res.data?.length > 0) {
        
        existingData = res.data[0]; // Assuming API returns an array
        isUpdate = true;
      }
    } catch (err) {
      console.warn("Belum ada data personalisasi");
    }

    // ===============================
    // 2️⃣ SHOW FORM (WITH PREFILL)
    // ===============================
    const { value: formValues } = await Swal.fire({
      title: "Personalisasi",
      html: `
        <div class="befa-form">
          <div class="befa-field">
            <label>Role Pekerjaan</label>
            <input 
              id="role"
              class="befa-input"
              placeholder="Role Pekerjaan Anda saat ini"
              maxlength="150"
              value="${existingData?.role || ""}"
            />
          </div>

          <div class="befa-field">
            <label>Tugas</label>
            <textarea 
              id="task"
              class="befa-textarea"
              placeholder="Tugas yang dikerjakan"
              maxlength="500"
            >${existingData?.tugas || ""}</textarea>
          </div>

          <div class="befa-field">
            <label>Preferensi</label>
            <textarea 
              id="preference"
              class="befa-textarea"
              placeholder="Preferensi terkait pekerjaan dan tugas yang perlu diingat"
              maxlength="500"
            >${existingData?.preferensi || ""}</textarea>
          </div>
        </div>
      `,
      showCloseButton: true,
      confirmButtonText: "Simpan",
      customClass: {
        popup: "befa-swal",
        confirmButton: "befa-btn-primary",
      },
      preConfirm: () => {
        const role = document.getElementById("role").value.trim();
        const task = document.getElementById("task").value.trim();
        const preference = document.getElementById("preference").value.trim();

        if (!role || !task) {
          Swal.showValidationMessage("Role dan Tugas wajib diisi");
          return;
        }

        return { role, task, preference };
      },
    });

    if (!formValues) return;

    // ===============================
    // 3️⃣ INSERT OR UPDATE
    // ===============================
    try {
      console.log(isUpdate ? "Updating personalisasi..." : "Inserting new personalisasi...");
      if (isUpdate) {
        await axios.post(
          `${process.env.REACT_APP_PATH_DESTINATION}/updatePersonalisasi`,
          formValues,
          { headers: { "x-access-token": token } }
        );
      } else {
        await axios.post(
          `${process.env.REACT_APP_PATH_DESTINATION}/insertPersonalisasi`,
          formValues,
          { headers: { "x-access-token": token } }
        );
      }

      Swal.fire({
        icon: "success",
        title: "Berhasil",
        text: "Personalisasi berhasil disimpan",
        confirmButtonColor: "#3085d6",
      });
    } catch (err) {
      console.error("❌ Gagal simpan personalisasi:", err);
      Swal.fire({
        icon: "error",
        title: "Gagal",
        text: "Terjadi kesalahan saat menyimpan data",
      });
    }
  };

  const [memoryList, setMemoryList] = useState([
    { id: 1, text: 'Engine deployment menggunakan Node.js + PM2' },
    { id: 2, text: 'Gunakan kebijakan BeFa sebagai rujukan utama' }
  ]);
  const [showMemory, setShowMemory] = useState(false);

  const [memorySearch, setMemorySearch] = useState('');

  function handleDeleteMemory(id) {
    console.log('Delete memory:', id);
    // panggil API / hapus dari state / SweetAlert dll
  }

  const handleMemoryzation = async () => {
  await Swal.fire({
    html: `<div id="memory-root"></div>`,
    showConfirmButton: false,
    showCloseButton: false,
    customClass: { popup: "befa-swal-white" },

    didOpen: () => {
      memoryRootRef.current = document.getElementById("memory-root");
      setShowMemory(true); // ✅ INI YANG HILANG
      setTimeout(() => {
    setShowMemory(true);
  }, 0);
    },

    willClose: () => {
      setShowMemory(false);
      memoryRootRef.current = null;
    }
  });
};

  return (
    <div className={`font-befa sidebar ${collapsed ? "collapsed" : ""}`}>
      <div className="sidebar-section header">
        {!collapsed && (
          <img
            src="/dist/img/befa-logo-kecil.png"
            alt="Logo"
            className="sidebar-logo"
            style={{ width: "22px" }}
          />
        )}
        <button
          style={{marginLeft:collapsed?"":"155px" }}
          className="menu-btn"
          onClick={() => setCollapsed(!collapsed)}
          title={collapsed ? "Expand Sidebar" : "Collapse Sidebar"}
        >
          {collapsed ? <ChevronRight size={22} /> : <Xmark size={22} />}
        </button>
      </div>

      {/* Left Scroll Start Here */}
      <div 
        className="leftScroll"
        ref={leftScrollRef}
        onScroll={handleScroll}

      >
        
{/* Top Menu */}
<div className= {collapsed? "sidebar-section top-menu-collapsed":"sidebar-section top-menu"}>
  {topMenu.map((item, i) => (
    <MenuItemWithTooltip
      key={i}
      item={item}
      collapsed={collapsed}
      index={i}
      hoveredItem={hoveredItem}
      setHoveredItem={setHoveredItem}
    />
  ))}
</div>

      {!collapsed && false &&( //&& false untuk menyembunyikan fitur proyek baru
        <div className="sidebar-section project">
          <div className="menu-item">
            <FolderPlus size={22} />
            <span>Proyek Baru</span>
          </div>
        </div>
      )}
{!collapsed && (<div style={{marginTop:'20px'}}>
<span style={{ color:'#A3AEB7' , marginLeft:'18px', fontFamily:'Montserrat', fontSize:'12px'}}>Histori</span>

</div>)}

{!collapsed && (<>
  {/* DISPLAY ITEMS */}
{displayedItems.map((chat, i) => (
  <div
    key={chat.id || i}
    className="history-item"
    onClick={() => onSelectChat && onSelectChat(chat.id)}
    style={{
      position: "relative", // This is important for absolute positioning of children
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      paddingLeft: "8px",
      paddingRight: "8px",
      cursor: "pointer",
    }}
  >
    {/* Text container that takes full width but leaves space for the icon */}
    <div style={{ 
      flex: 1, 
      position: "relative",
      overflow:'hidden',
      minHeight: "20px" // Ensure consistent height
    }}>
      {/* Judul Chat */}
      {editingId === chat.id ? (
        <input
          type="text"
          value={editValue}
          onChange={(e) => setEditValue(e.target.value)}
          onBlur={(e) => {
            const newVal = e.target.value.trim();
            if (!newVal || newVal === chat.judul_chat) {
              setEditingId(null);
              return;
            }

            // Update local display
            setDisplayedItems(prev => 
              prev.map(c => c.id === chat.id ? { ...c, judul_chat: newVal } : c)
            );
            setLocalList(prev => 
              prev.map(c => c.id === chat.id ? { ...c, judul_chat: newVal } : c)
            );

            setEditingId(null);
            handleUpdateTitle(chat.id, newVal);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") e.currentTarget.blur();
            else if (e.key === "Escape") setEditingId(null);
          }}
          autoFocus
          style={{
            width: "100%",
            padding: "4px 6px",
            borderRadius: "4px",
            border: "1px solid #ccc",
          }}
        />
      ) : (
        <span
          onDoubleClick={() => {
            setEditingId(chat.id);
            setEditValue(chat.judul_chat || chat.title || "");
          }}
          style={{ 
            display: "block",
            width: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            paddingRight:"24px",
          }}
        >
          {chat.judul_chat || chat.title || `Chat #${i + 1}`}
        </span>
      )}
    </div>

    {/* More icon - positioned absolutely on the right */}
    <img
      src="/dist/img/more-horiz.png"
      alt="More"
      className="more-icon"
      onClick={(e) => {
        e.stopPropagation();
        toggleMenu(i);
      }}
      style={{
        position: "absolute",
        right: "8px",
        top: "50%",
        transform: "translateY(-50%)",
        width: "16px",
        height: "16px",
        opacity: 0,
        zIndex: 1
      }}
    />

    {openMenuIndex === i && (
      <div className="more-menu" ref={menuRef} style={{
        position: "absolute",
        right: "8px",
        top: "100%",
        padding:"0px",
        zIndex: 10
      }}>
        <div className="hoverclass" onClick={() => handleMenuClick("ubah", chat)} style={{padding:'10px'}}>
          <EditPencil/> Ubah Judul
        </div>
        <div className="hoverclass" onClick={() => handleMenuClick("hapus", chat)} style={{padding:'10px', color:'red'}}>
          <BinMinusIn/> Hapus Obrolan
        </div>
      </div>
    )}
  </div>
))}
</>)}


      {/* Left Scroll Ends Here */}
      </div>

      {/* Footer */}
<div
  className="sidebar-section footer"
  ref={footerRef}
  style={{ position: "relative" }}
>
  <div
    className="footer-user"
    onClick={(e) => {
      e.stopPropagation();
      setFooterMenuOpen(!footerMenuOpen);
    }}

    style={{ position: "relative" }}
  >
    <div className="user-avatar">
      {userData?.fullname
        ? userData.fullname.charAt(0).toUpperCase()
        : "U"}
    </div>
    {!collapsed && <span style={{color:'black'}}>{userData.fullname || "User Name"}</span>}
    
    {/* Tooltip element */}
    {showTooltip && collapsed && (
      <div className="user-tooltip">
        {userData?.fullname || "User Name"}
      </div>
    )}
  </div>
</div>
      {/* Menu rendered via portal */}
      {footerMenuOpen && (
        <FooterMenu 
          ref={footerRef}
          sessionData={sessionData}
          portalURL={portalURL}
          handleLogout={handleLogout}
          onClose={() => setFooterMenuOpen(false)}
          anchorRef={footerRef}
          collapsed={collapsed}
        />
      )}
      <SearchChatModal
        visible={searchModalVisible}
        onClose={() => setSearchModalVisible(false)}
        masterChatList={masterChatList}
        onSelectChat={(id) => {
          if (id === "new") onNewChat();
          else onSelectChat && onSelectChat(id);
        }}
      />
      {showMemory && memoryRootRef.current &&
  createPortal(
    <MemoryModal
      memories={memoryList}
      setMemories={setMemoryList}
      onClose={() => Swal.close()}
    />,
    memoryRootRef.current
  )
}
    </div>
  );
};

export default Sidebar;
